interface SubSubSubmenuItem {
    title: string;
    route_name: string;
    route_params?: Object;
}

interface SubSubmenuItem {
    title: string;
    route_name?: string;
    route_params?: Object;
    submenu?: SubSubSubmenuItem[];
    icon_path?: string;
}

interface SubmenuItem {
    title?: string;
    route_name?: string;
    route_params?: Object;
    submenu: SubSubmenuItem[];
}

interface MenuItem {
    title: string;
    route_name?: string;
    route_params?: Object;
    submenu?: SubmenuItem[];
    type?: string;
    isOpen?: boolean;
}

interface MenuConfig {
    menuItems: MenuItem[];
}

import dorplity_img from '@img/production_icons/dorplity.webp'
import aerodrom_plity_img from '@img/production_icons/aerodrom_plity.webp'
import plity_perekitya_img from '@img/production_icons/plity_perekitya.webp'
import fbs_img from '@img/production_icons/fbs.webp'

const menuConfig: MenuConfig = {
    menuItems: [
        {
            title: "Каталог ЖБИ",
            route_name: "catalog",
        },
        {
            type: 'products_menu',
            title: "Продукция",
            submenu: [
                {
                    title: "Дорожно-транспортное строительство",
                    submenu: [
                        {
                            title: "Дорожные плиты",
                            route_name: "catalog",
                            icon_path: dorplity_img,
                            route_params: {
                                base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva'])
                            },
                            submenu: [
                                {
                                    title: "ПДП",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['pdp']),
                                    },
                                },
                                {
                                    title: "2П30",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['2p30'])
                                    },
                                },
                                {
                                    title: "1П30",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['1p30'])
                                    },
                                },
                                {
                                    title: "1П35",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                        categories: JSON.stringify(['plity-dlya-dorozhnogo-stroitelstva']),
                                        sub_categories: JSON.stringify(['1p35'])
                                    },
                                },
                            ],
                        },
                        {
                            title: "Аэродромные плиты",
                            route_name: "catalog",
                            icon_path: aerodrom_plity_img,
                            route_params: {
                                base_categories: JSON.stringify(['dorozhno-transportnoe-stroitelstvo']),
                                categories: JSON.stringify(['aerodromnye-plity'])
                            },
                            submenu: [
                                {
                                    title: "ПАГ-14 ГОСТ",
                                    route_name: "product.show",
                                    route_params: {path: 'dorozhno-transportnoe-stroitelstvo/aerodromnye-plity/pag-14-gost'},
                                },
                                {
                                    title: "ПАГ-14 ТУ",
                                    route_name: "product.show",
                                    route_params: {path: 'dorozhno-transportnoe-stroitelstvo/aerodromnye-plity/pag-14-tu'},
                                },
                                {
                                    title: "ПДН 6х2",
                                    route_name: "product.show",
                                    route_params: {path: 'dorozhno-transportnoe-stroitelstvo/aerodromnye-plity/pdn-6kh2'},
                                },
                                {
                                    title: "ПАГ-18 ГОСТ",
                                    route_name: "product.show",
                                    route_params: {path: 'dorozhno-transportnoe-stroitelstvo/aerodromnye-plity/pag-18-gost'},
                                },
                            ],
                        },
                        {
                            title: "Плиты перекрытия",
                            route_name: "catalog",
                            icon_path: plity_perekitya_img,
                            route_params: {
                                base_categories: JSON.stringify(['elementy-zdaniy-i-sooruzheniy']),
                                categories: JSON.stringify(['plity-perekrytiya']),
                            },
                            submenu: [
                                {
                                    title: "Пустотные плиты перекрытия",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['elementy-zdaniy-i-sooruzheniy']),
                                        categories: JSON.stringify(['plity-perekrytiya']),
                                        sub_categories: JSON.stringify(['pustotnye-plity-perekrytiya'])
                                    },
                                },
                                {
                                    title: "Ребристые плиты перекрытия",
                                    route_name: "catalog",
                                    route_params: {
                                        base_categories: JSON.stringify(['elementy-zdaniy-i-sooruzheniy']),
                                        categories: JSON.stringify(['plity-perekrytiya']),
                                        sub_categories: JSON.stringify(['rebristye-plity-perekrytiya'])
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    title: "Фундамент",
                    submenu: [
                        {
                            title: "Фундаментные блоки ФБС",
                            route_name: "catalog",
                            icon_path: fbs_img,
                            route_params: {
                                base_categories: JSON.stringify(['elementy-zdaniy-i-sooruzheniy']),
                                categories: JSON.stringify(['fundament']),
                                sub_categories: JSON.stringify(['fundamentnye-bloki-fbs'])
                            },
                            submenu: [
                                {
                                    title: 'ФБС-24-3-6',
                                    route_name: "product.show",
                                    route_params: {path: 'elementy-zdaniy-i-sooruzheniy/fundament/fundamentnye-bloki-fbs/fbs-24-3-6'},
                                },
                                {
                                    title: 'ФБС-20-3-6',
                                    route_name: "product.show",
                                    route_params: {path: 'elementy-zdaniy-i-sooruzheniy/fundament/fundamentnye-bloki-fbs/fbs-20-3-6'},
                                },
                                {
                                    title: 'ФБС-18-3-6',
                                    route_name: "product.show",
                                    route_params: {path: 'elementy-zdaniy-i-sooruzheniy/fundament/fundamentnye-bloki-fbs/fbs-18-3-6'},
                                },
                                {
                                    title: 'ФБС-12-3-6',
                                    route_name: "product.show",
                                    route_params: {path: 'elementy-zdaniy-i-sooruzheniy/fundament/fundamentnye-bloki-fbs/fbs-12-3-6'},
                                },
                            ]
                        },
                    ],
                },
            ],
            isOpen: false,
        },
        {
            title: "Услуги",
            route_name: "services",
        },
        {
            title: "О компании",
            route_name: "aboutCompany",
        },
        {
            title: "Контакты",
            route_name: "contacts",
        },
        {
            title: "Отзывы",
            route_name: "otzyvy",
        },
    ],
};

export default menuConfig;
